module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.10-112.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.5.10.md
// module id = 529
// module chunks = 287